const QuotaRoutes = [
    {
        path: 'quotaConfig',
        name: 'quotaConfig',
        component: () => import ('@/views/Quota/QuotaConfig/quotaConfig'),
        meta: { 
            keepAlive: true,
            title: 'indicatorSetting'
        },
        children: [
            {
                path: 'indicatorInsert',
                name: 'indicatorInsert',
                component: () => import ('@/views/Quota/QuotaConfig/indicatorLibrary/insert.vue'),
                meta: { 
                    keepAlive: true,
                    title: 'addIndicator'
                },
            },
            {
                path: 'indicatorUpdate',
                name: 'indicatorUpdate',
                component: () => import ('@/views/Quota/QuotaConfig/indicatorLibrary/insert.vue'),
                meta: { 
                    keepAlive: true,
                    title: 'edit'
                },
            },
            {
                path: 'indicatorPreview',
                name: 'indicatorPreview',
                component: () => import ('@/views/Quota/QuotaConfig/indicatorLibrary/insert.vue'),
                meta: { 
                    keepAlive: true,
                    title: 'detail'
                },
            },
        ]
    },
    {
        path: 'compEval',
        name: 'compEval',
        component: () => import ('@/views/Quota/comprehensiveEvaluation'),
        meta: { 
            keepAlive: true,
            title: 'compEval'
        },
    },
    {
        path: 'rankConfig',
        name: 'rankConfig',
        component: () => import('@/views/Quota/RankConfig/rankConfig.vue'),
        meta: { 
            keepAlive: true,
            title: 'rankingSettings'
        },
    },
    {
        path: 'executiveTarget',
        name: 'executiveTarget',
        component: () => import('@/views/Quota/ExecutiveSetting/index.vue'),
        meta: { 
            keepAlive: true,
            title: 'executiveTarget'
        },
    },
    {
        path: 'linkConfig',
        name: 'linkConfig',
        component: () => import('@/views/Quota/LinkConfig/linkConfig.vue'),
        meta: { 
            keepAlive: true,
            title: 'commonLinks'
        },
    },
    {
        path: 'linkEdit',
        name: 'linkEdit',
        component: () => import('@/views/Quota/LinkConfig/linkEdit.vue'),
        meta: { 
            keepAlive: true,
            title: 'commonLinks'
        },
    },
    {
        path: 'linkPreview',
        name: 'linkPreview',
        component: () => import('@/views/Quota/LinkConfig/linkPreview.vue'),
        meta: { 
            keepAlive: true,
            title: 'commonLinks'
        },
    },
    {
        path: 'doubleInspection',
        name: 'doubleInspection',
        component: () => import('@/views/Quota/DoubleInspection'),
        meta: { 
            keepAlive: true,
            title: 'haveBusiness'
        },
    },
    {
        path: 'executiveList',
        name: 'executiveList',
        component: () => import('@/views/Quota/ExecutiveList'),
        meta: { 
            keepAlive: true,
            title: 'executiveList'
        },
    },
    {
        path: 'kpiPeriod',
        name: 'kpiPeriod',
        component: () => import('@/views/Quota/KPIPeriod'),
        meta: { 
            keepAlive: true,
            title: 'cycleSetting'
        },
    },
    {
        path: 'userBonusLimit',
        name: 'userBonusLimit',
        component: () => import('@/views/Quota/UserBonusLimit'),
        meta: { 
            keepAlive: true,
            title: 'setBonusCap'
        },
    },
]

export default QuotaRoutes